// src/app/core/browser-session.service.ts
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from './_services/user.service';

@Injectable({ providedIn: 'root' })
export class BrowserSessionService {
  private initialized = false;
  private readonly SESSION_FLAG = 'session-alive';       // sessionStorage
  private readonly APP_SEEN = 'app_seen';                // persistent cookie you DO NOT clear

  private platformId = inject(PLATFORM_ID);
  private cookies = inject(CookieService);
  private userService = inject<any>(UserService);
  init(): void {
    if (this.initialized) return;
    this.initialized = true;

    if (!isPlatformBrowser(this.platformId)) return;

    const sessionAlive = sessionStorage.getItem(this.SESSION_FLAG) === '1';
    const appSeen = this.cookies.check(this.APP_SEEN);

    // If we've been seen before, but this session isn't alive yet,
    // it means last end was a REAL CLOSE (not a refresh) → clear now.
    if (appSeen && !sessionAlive) {
      this.clearOnClose();
    }

    // Mark app as seen (persistent, do NOT clear this cookie in clearOnClose)
    if (!appSeen) {
      // Set cookie for a long time; adjust domain/path as needed
      this.cookies.set(this.APP_SEEN, '1', { expires: 365, path: document.location.hostname });
    }

    // Mark current tab-session as alive (survives refresh)
    sessionStorage.setItem(this.SESSION_FLAG, '1');
  }

  private clearOnClose() {
    try {
      // IMPORTANT: path/domain must match how the cookie was set
      this.userService.logoutUser();
      this.cookies.delete('loginSubscriptionData', '/');
      this.cookies.delete('loginSubscriptionData', '/', document.location.hostname);
       localStorage.clear();
      sessionStorage.clear();
      // If you set a domain, use: this.cookies.delete('loginSubscriptionData', '/', '.yourdomain.com');

      // If you must clear storage too, do it here (optional):
      // localStorage.removeItem('whatever'); // avoid wholesale clear if possible
      // sessionStorage.clear();

      // DO NOT delete the 'app_seen' cookie here!
    } catch { /* no-op */ }
  }
}
